export const ACCEPTED_FILE_TYPES = [
  // MS Office Documents (DOC/XLS/PPT) - Office 2007 and later
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx

  // OpenDocument Formats (ODT/ODS/ODP)
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',

  // PDF
  'application/pdf',
  // HTML
  'text/html',

  // Markdown (Often detected as plain text)
  'text/markdown',
  'text/plain',

  // Images
  'image/jpeg',
  'image/png',

  // Video
  'video/mp4',
  'video/quicktime',

  // Archive Formats (ZIP, TAR, GZ, RAR)
  'application/zip',
  'application/x-zip-compressed',
  'application/x-tar',
  'application/gzip',
  'application/x-gzip',
  'application/x-rar-compressed',
];

export const ACCCEPTED_FILE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.odt',
  '.ods',
  '.odp',
  '.pdf',
  '.html',
  '.md',
  '.txt',
  '.mp4',
  '.mov',
  '.jpg',
  '.png',
  '.zip',
  '.tar',
  '.gz',
  '.rar',
];
